import { deleteSnapLiked as deleteSnapLikedApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import {
  type DeleteSnapLikedServiceRequest,
  DeleteSnapLikedServiceRequestSchema,
  type DeleteSnapLikedServiceResponse,
  DeleteSnapLikedServiceResponseSchema,
} from './delete-snap-liked.dto';

export const deleteSnapLikedService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(DeleteSnapLikedServiceRequestSchema),
    async (request: DeleteSnapLikedServiceRequest): Promise<DeleteSnapLikedServiceResponse> => {
      const apiResponse = await deleteSnapLikedApi({ snapId: request.snapId });
      return {
        success: apiResponse.meta?.result === 'SUCCESS',
      };
    },
    validateServiceResponse(DeleteSnapLikedServiceResponseSchema),
  ),
);
